
export default {
  get: name => {
    const parts = `; ${document.cookie}`.split(`; ${name}=`)
    return parts.length < 2 ? undefined : parts.pop().split(';').shift()
  },

  set: (name, value, expiryDays, domain, path, secure) => {
    const expiryDate = new Date(new Date().setDate(new Date().getDate() + (expiryDays || 365))).toUTCString()
    const cookie = [`${name}=${value}`]

    cookie.push(`expires=${expiryDate}`)
    cookie.push(`path=${path || '/'}`)
    cookie.push('samesite=lax')

    if (domain) {
      cookie.push(`domain=${domain}`)
    }

    if (secure !== false && window.location.protocol === 'https:') {
      cookie.push('secure')
    }

    document.cookie = cookie.join(';')
  }
}
